import http from 'plugins/axios';

export default {
  smsEmailSendRecordList(data) {
    return http.post({
        url: '/admin/smsemail/smsEmailSendRecordList',
        data,
        dataType: 'form'
    })
},
};
